/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PlannerPromotionStartRequest
 */
export interface PlannerPromotionStartRequest {
  /**
   * Client-created UUID retained across retries of this start, scoped to the authenticated user.
   * @type {string}
   * @memberof PlannerPromotionStartRequest
   */
  requestId: string;
}

/**
 * Check if a given object implements the PlannerPromotionStartRequest interface.
 */
export function instanceOfPlannerPromotionStartRequest(
  value: object
): value is PlannerPromotionStartRequest {
  if (!("requestId" in value) || value["requestId"] === undefined) return false;
  return true;
}

export function PlannerPromotionStartRequestFromJSON(
  json: any
): PlannerPromotionStartRequest {
  return PlannerPromotionStartRequestFromJSONTyped(json, false);
}

export function PlannerPromotionStartRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PlannerPromotionStartRequest {
  if (json == null) {
    return json;
  }
  return {
    requestId: json["request_id"],
  };
}

export function PlannerPromotionStartRequestToJSON(
  json: any
): PlannerPromotionStartRequest {
  return PlannerPromotionStartRequestToJSONTyped(json, false);
}

export function PlannerPromotionStartRequestToJSONTyped(
  value?: PlannerPromotionStartRequest | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    request_id: value["requestId"],
  };
}
